import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERCOLUMNITEMBLOCK_LEGACY_FIELD_ORDER = [
  "name",
  "link",
  "open_in_new_tab"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterColumnItemBlockDescriptor: _generatedBigFooterColumnItemBlockDescriptor,
  bigFooterColumnItemBlockBlocDefinition,
  bigFooterColumnItemBlockDashboardLayout,
  bigFooterColumnItemBlockConfig,
  bigFooterColumnItemBlockResolveConfig,
  bigFooterColumnItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Big footer - Column item",
    componentType: 'BigFooterColumnItemBlockComponent',
    category: 'footer',
    description: "Big footer - Column item.",
    keywords: [],
    allowedIn: [
      { bloc: "BigFooterColumnBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    name: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-column-item.name.label",
      }
    }),
    link: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.big-footer-column-item.link.label",
      }
    }),
    open_in_new_tab: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.big-footer-column-item.open-in-new-tab.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer-column-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer-column-item.fieldset.link.label",
            fields: ["name", "link", "open_in_new_tab"],
          },
        ],
      },
    ],
  })
);

export function bigFooterColumnItemBlockDescriptor(): IBlockDescriptor;
export function bigFooterColumnItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterColumnItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterColumnItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterColumnItemBlockDescriptor, bigFooterColumnItemBlockProperties, fieldOrder);
}

export {
  bigFooterColumnItemBlockBlocDefinition,
  bigFooterColumnItemBlockDashboardLayout,
  bigFooterColumnItemBlockProperties,
  bigFooterColumnItemBlockConfig,
  bigFooterColumnItemBlockResolveConfig,
};

export type BigFooterColumnItemBlockConfig = typeof bigFooterColumnItemBlockConfig;
